/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'submit': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M925.867 221.867c-17.067-17.067-42.667-17.067-59.734 0L379.733 729.6c-4.266 4.267-12.8 8.533-17.066 8.533-4.267 0-8.534 0-17.067-8.533l-192-196.267c-17.067-17.066-42.667-17.066-59.733 0C76.8 550.4 76.8 576 93.867 593.067l192 196.266c21.333 21.334 46.933 34.134 76.8 34.134s55.466-12.8 76.8-34.134l486.4-507.733c17.066-17.067 17.066-46.933 0-59.733z"/>'
  }
})
